// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9cadcb71c3--container--M8a6T","info":"_9cadcb71c3--info--GOAiR","icon":"_9cadcb71c3--icon--bN2Im"};